module.exports = __webpack_public_path__ + "static/media/nz.b14c3467.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nz.svg
// module id = 216
// module chunks = 0